import delve from "dlv";
import { FAQAlgoliaHit, FormattedResult } from "../ts/types";

type URLConstructionMapping = [string, string];

export const questionURLFormatter = (
  url: string,
  constructionMappings: URLConstructionMapping[]
) => (hit: FAQAlgoliaHit): string =>
  constructionMappings.reduce(
    (urlWithParameters, [parameterPattern, valuePath]) => {
      return urlWithParameters.replace(parameterPattern, delve(hit, valuePath));
    },
    url
  );

export default routingConfig => {
  const { url, parameters } = routingConfig;

  const urlParametersAccessMapping: URLConstructionMapping[] = Object.entries(
    parameters
  );

  const formatQuestionURL = questionURLFormatter(
    url,
    urlParametersAccessMapping
  );

  return (searchHits: FAQAlgoliaHit[]): FormattedResult[] =>
    searchHits.map(hit => ({
      breadcrumb: [
        hit.question.category.thematic.label,
        hit.question.category.label,
      ],
      title: hit.question.label,
      url: formatQuestionURL(hit),
      thematicId: hit.question.category.thematic.id,
      categoryId: hit.question.category.id,
      questionId: hit.question.id,
    }));
};
